import request from '@/http/request'

/** 辽宁 ETC 独立收银台 */
export function fetchLnetcCashierPage (orderId, token) {
  return request.request({
    url: '/api/pay/lnetc/page',
    method: 'GET',
    params: {
      orderId: String(orderId),
      t: token
    }
  })
}

export function executeLnetcPay (orderId, token) {
  return request.request({
    url: '/api/pay/lnetc/execute',
    method: 'POST',
    timeout: 90000,
    data: {
      orderId: String(orderId),
      t: token
    }
  }, true, false, false)
}

/** 直付通科技独立收银台 */
export function fetchZhifutdCashierPage (orderId, token) {
  return request.request({
    url: '/api/pay/zhifutd/page',
    method: 'GET',
    params: {
      orderId: String(orderId),
      t: token
    }
  })
}

export function executeZhifutdPay (orderId, token) {
  return request.request({
    url: '/api/pay/zhifutd/execute',
    method: 'POST',
    timeout: 90000,
    data: {
      orderId: String(orderId),
      t: token
    }
  }, true, false, false)
}

/** 讯石售货机独立收银台 */
export function fetchYwzfCashierPage (orderId, token) {
  return request.request({
    url: '/api/pay/ywzf/page',
    method: 'GET',
    params: {
      orderId: String(orderId),
      t: token
    }
  })
}

export function executeYwzfPay (orderId, token, code) {
  return request.request({
    url: '/api/pay/ywzf/execute',
    method: 'POST',
    timeout: 90000,
    data: {
      orderId: String(orderId),
      t: token,
      code: code || ''
    }
  }, true, false, false)
}

/** 银联聚合码收银台（建行 jhuid / 邮政 yz / 农行 nh / 浙江商行 zjfs / 工行 gh / 邮惠付 yzyhf / 湖北农信 hbnx / 旺铺管家 wpgj） */
export function fetchBankAggCashierPage (channelKey, orderId, token) {
  const channel = String(channelKey || '').trim().toLowerCase()
  return request.request({
    url: `/api/pay/${channel}/page`,
    method: 'GET',
    params: {
      orderId: String(orderId),
      t: token
    }
  })
}

/** 支付宝转卡收银台（金额+卡号，无二维码） */
export function fetchAlipayCardCashierPage (orderId, token, statusPoll) {
  const params = {
    orderId: String(orderId),
    t: token
  }
  if (statusPoll) {
    params.poll = '1'
  }
  return request.request({
    url: '/api/pay/alipaycard/page',
    method: 'GET',
    params
  })
}

/** 支付宝转卡：提交付款人姓名末字写入订单 extInfo */
export function submitAlipayCardPayerName (orderId, token, payerName) {
  return request.request({
    url: '/api/pay/alipaycard/payer-name',
    method: 'POST',
    data: {
      orderId: String(orderId),
      t: token,
      payerName: String(payerName || '').trim()
    }
  }, true, true, false)
}

/** 统一收银台页面上下文（与模板 Model 一致，不调渠道） */
export function fetchUnifiedCashierPage (orderId, token) {
  return request.request({
    url: '/api/pay/unified/page',
    method: 'GET',
    params: {
      orderId: String(orderId),
      t: token
    }
  })
}

/** 统一收银台真实拉单（前后分离版） */
export function executeUnifiedPay (orderId, token) {
  return request.request({
    url: '/api/pay/unified/execute',
    method: 'POST',
    timeout: 90000,
    data: {
      orderId: String(orderId),
      t: token
    }
  }, true, false, false)
}

/** UID 手动回调收银台（先填真实姓名，再打开支付宝） */
export function fetchUidManualCashierPage (orderId, token, statusPoll) {
  const params = {
    orderId: String(orderId),
    t: token
  }
  if (statusPoll) {
    params.poll = '1'
  }
  return request.request({
    url: '/api/pay/uidmanual/page',
    method: 'GET',
    params
  })
}

/** UID 手动回调：提交付款人真实姓名写入订单 extInfo */
export function submitUidManualPayerName (orderId, token, payerName) {
  return request.request({
    url: '/api/pay/uidmanual/payer-name',
    method: 'POST',
    data: {
      orderId: String(orderId),
      t: token,
      payerName: String(payerName || '').trim()
    }
  }, true, true, false)
}

/** 手动回调：提交付款人真实姓名写入订单 extInfo */
export function submitUnifiedPayerName (orderId, token, payerName) {
  return request.request({
    url: '/api/pay/unified/payer-name',
    method: 'POST',
    data: {
      orderId: String(orderId),
      t: token,
      payerName: String(payerName || '').trim()
    }
  }, true, true, false)
}

/** JSAPI 收银页 API（context-path=/api，与 unified/lnetc 一致） */
export function fetchWxJsOrderBrief (orderId, token) {
  return request.request({
    url: '/api/channelbiz/wxjs/orderBrief',
    method: 'GET',
    params: {
      orderId: String(orderId),
      t: token
    }
  })
}

export function queryWxJsOrder (orderId, token) {
  return request.request({
    url: '/api/channelbiz/wxjs/query',
    method: 'GET',
    params: {
      orderId: String(orderId),
      t: token
    }
  }, true, true, false)
}

/**
 * 代付开放接口（无登录态，请求体自带 mchId+sign）。
 * 关闭拦截器，保留完整 {code,message,data,sign}。
 */
export function postSalaryOpenApi (absoluteUrl, body) {
  return request.request({
    url: absoluteUrl,
    method: 'POST',
    timeout: 90000,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    data: body
  }, false, false, false)
}
